import { IFilterCalendarioSsoModel } from "../interfaces/calendario-sso/IFilterCalendarioSsoModel";

export class FilterCalendarioSsoModel implements IFilterCalendarioSsoModel{
    anio: number;
    idCompania: number;
    page: number;
    pageSize: number;

    constructor(){
        this.anio= new Date().getFullYear();
        this.page = 1;
        this.pageSize = 30;
        this.idCompania = 0;
    }
}